import React from "react";
const initialState = {
    baseUrl: "",
    endpoints: {
        signIn: "",
        signOut: "",
        refresh: "",
    },
    accessToken: "",
    refreshToken: "",
    isAuth: false,
    isLoading: false,
    errors: null,
};
const AuthContext = React.createContext({ state: initialState, dispatch: () => null });
export { AuthContext, initialState };
//# sourceMappingURL=context.js.map